import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button, toast } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useDeleteLevel, useLevelQuery, useUpdateLevel } from "../api/queries";
import { LevelForm } from "../ui/levels/LevelForm";

export function LevelEditPage() {
  const nav = useNavigate({
    from: "/app/master/levels/$id/edit",
  });
  const { id } = useParams({ from: "/app/master/levels/$id/edit" });
  const { data, ...result } = useLevelQuery(id);
  const updateLevel = useUpdateLevel(id);
  const deleteLevel = useDeleteLevel();

  const level = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ລະດັບ", to: "/app/master/levels" },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ແກ້ໄຂລະດັບ
            </h2>
            <p className="text-muted-foreground">ປັບປຸງລາຍລະອຽດຂອງລະດັບ.</p>
          </div>

          <div className="flex gap-2">
            <Button
              variant="destructive"
              onClick={async () => {
                const ok = await import("@devhop/ui").then((m) =>
                  m.confirm({
                    title: "ລຶບລະດັບ",
                    description: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບລະດັບນີ້?",
                    actionText: "ລຶບ",
                    ActionProps: {
                      variant: "destructive",
                    },
                  }),
                );
                if (!ok) return;

                try {
                  await toast.promise(deleteLevel.run(id), {
                    loading: "ກຳລັງລຶບ...",
                    success: () => {
                      nav({ to: "/app/master/levels" });
                      return "ລຶບລະດັບສຳເລັດ";
                    },
                    error: "ລຶບລະດັບລົ້ມເຫຼວ",
                  });
                } catch (error) {
                  // Error handling is done by toast.promise
                }
              }}
            >
              ລຶບ
            </Button>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/master/levels" })}
            >
              <ArrowLeftIcon className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດລະດັບ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!level ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <LevelForm
                initialValues={{
                  name: level.name,
                  description: level.description || "",
                  order: level.order ?? undefined,
                  status: level.status,
                }}
                onSubmit={async (vals) => {
                  try {
                    await updateLevel.mutateAsync(vals);

                    nav({ to: "/app/master/levels" });
                  } catch (error) {
                    // Error handling is done by the mutation
                  }
                }}
                submitting={updateLevel.isPending}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
